import { PureComponent } from "react";
import classnames from "classnames";
import Picture from "/components/core/picture/picture-component";

import CheckListChecked from "/static/svg/checklist_checked.svg";
import CheckListEmpty from "/static/svg/checklist_empty.svg";

import { componentStyles } from "./cluster-option-component.scss";

export default class ClusterOptionComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.onSelect = this.onSelect.bind(this);
  }

  onSelect() {
    const { selectCallback, option } = this.props;
    selectCallback(option.id);
  }

  render() {
    const { selected, singleImage, option, showCheckboxIcon } = this.props;

    const image = singleImage && option.detailsImage ? option.detailsImage : option.image;
    const text = singleImage && option.detailsText ? option.detailsText : option.text;

    const ChecklistComponent = singleImage ? CheckListChecked : CheckListEmpty;

    return (
      <div
        className={classnames("cluster-manage-option", {
          selected: selected,
          "big-image": singleImage
        })}
        onMouseDown={this.onSelect}
      >
        <div className="cluster-image-wrapper">
          <img className="cluster-option-image" src={image} />
        </div>
        <div className={classnames("cluster-text-wrapper", { "with-checkbox": showCheckboxIcon })}>
          {showCheckboxIcon && <ChecklistComponent />}
          <div className={classnames("cluster-option-text", { "is-other": option.detailsText })}> {text}</div>
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
